/* eslint-disable eqeqeq */
import { useState } from "react";
import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../../helpers";
import { useGetStockRemovalRequestsList } from "../../../../hooks/api/queries/useInventory";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";
import { stockRemovalStatusTabs } from "../../../../localdata";

const useStockRemovals = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const queries = getUrlQuerysection();
  const [isRemoveStock, setIsRemoveStock] = useState(false);

  const {
    search,
    gotoPage,
    filterByStoreId,
    filterByDate,
    filterBySearch,
    filterByKey,
  } = useUrlSearch();

  const [startDate] = useState(search.get("start_date"));
  const [endDate] = useState(search.get("end_date"));

  const {
    data: requestsData,
    isLoading: isLoadingRequests,
    refetch: handleFetchRequests,
  } = useGetStockRemovalRequestsList({ queries });

  const stockRemovals = requestsData?.data || [];
  const metaDetails = requestsData?.meta || {};
  const pendingCount = metaDetails?.total_in_review || 0;

  return {
    storeList,
    isLoadingRequests,
    stockRemovals,
    metaDetails,
    isRemoveStock,
    setIsRemoveStock,
    search,
    gotoPage,
    filterByStoreId,
    filterByDate,
    filterBySearch,
    filterByKey,
    startDate,
    endDate,
    stockRemovalStatusTabs,
    pendingCount,
    handleFetchRequests,
  };
};

export default useStockRemovals;
